import { useEffect, useState, Dispatch, SetStateAction, useMemo, useCallback } from "react";
import SearchBar from "../../../../components/Filtering/SearchBar"
import { useGetDatasetsDatasetGet, useGetDatasetTagsDatasetTagsGet } from "../../../../api/generated/fastAPI";
import { Dataset, DatasetListResponse, GetDatasetsDatasetGetParams } from "../../../../api/models";
import FilterBar from "../../../../components/Filtering/FilterBar";
import useDataParams, { GetParamsTypes } from "../../../../hooks/useDataParams";
import { defaultFilters, getDatasetParams } from "../../../../utils/supplementalData";
import PaginatedSelectList, { SelectListOption } from "../../../../components/Filtering/PaginatedSelectList";


export default function SelectDatasetV2({
    preselectedDatasetId,
    selectedDatasets,
    setSelectedDatasets,
    isPrefetching,
}: {
    preselectedDatasetId?: string,
    selectedDatasets: Dataset[],
    setSelectedDatasets: Dispatch<SetStateAction<Dataset[]>>,
    isPrefetching: boolean,
}) {
    const getDsTags = useGetDatasetTagsDatasetTagsGet();

    const {
        params,
        setParams,
        search,
        filters,
        setPaginationLimit,
        setPaginationOffset
    } = useDataParams({
        defaultParams: getDatasetParams(),
        defaultFilters,
        tagsData: getDsTags.data as unknown as { [key: string]: string[] },
    });


    const getDatasetsMutation = useGetDatasetsDatasetGet(params as GetParamsTypes);
    const [ datasets, setDatasets ] = useState<Dataset[]>([]);
    const [ count, setCount ] = useState(0);

    useEffect(() => {
        if (getDatasetsMutation.data) {
            const response = getDatasetsMutation.data as unknown as DatasetListResponse;
            const data = (response.datasets ?? []) as unknown as Dataset[];
            setDatasets(data);
            setCount(response.count ?? 0);
        }
    }, [getDatasetsMutation.data]);

    const availableOptions: SelectListOption[] = useMemo(() => {
        if (datasets.length === 0) return [];
        return datasets.map(ds => ({ id: ds.file_hash!, name: ds.name ?? '' }))
    }, [datasets]);

    const chosenOptions: SelectListOption[] = useMemo(() => {
        if (selectedDatasets.length === 0) return [];
        return selectedDatasets.map(ds => ({ id: ds.file_hash!, name: ds.name ?? '' }));
    }, [selectedDatasets]);

    const addDataset = useCallback((
        id: string | number,
    ) => {
        if (datasets.length === 0) return;

        const chosenDataset = datasets.find(ds => ds.file_hash === id.toString());

        if (chosenDataset) {
            setSelectedDatasets([chosenDataset])
        }
    }, [datasets, setSelectedDatasets]);

    const removeDataset = useCallback((
        id: string | number,
    ) => {
        setSelectedDatasets([]);
    }, [setSelectedDatasets]);


    return (
        <>
            <div className="flex flex-col gap-10">
                <div className="flex flex-col justify-start items-start gap-4">
                    <SearchBar
                        label="Search"
                        searchKey="name"
                        searchFn={search}
                    />
                    <FilterBar 
                        filters={filters}
                        setParams={setParams}
                        params={params}
                    />
                </div>
                <PaginatedSelectList 
                    availableOptions={availableOptions} 
                    chosenOptions={chosenOptions}
                    addOption={addDataset}
                    removeOption={removeDataset}
                    isMultiSelect={false}
                    isLoading={getDatasetsMutation.isLoading || isPrefetching}
                    isCountLoading={getDatasetsMutation.isLoading}
                    count={count}
                    setPaginationLimit={setPaginationLimit}
                    setPaginationOffset={setPaginationOffset}
                    params={params as GetParamsTypes}
                    showSelected={preselectedDatasetId !== undefined ? true : false}
                />
            </div>
        </>
    )
}